export const BALANCE_LIST_ATTEMPT = "BALANCE_LIST_ATTEMPT";
export const BALANCE_LIST_SUCCESS = "BALANCE_LIST_SUCCESS";
export const BALANCE_LIST_FAILED = "BALANCE_LIST_FAILED";
/////////////////////
export const BALANCE_MORELIST_ATTEMPT = "BALANCE_MORELIST_ATTEMPT";
export const BALANCE_MORELIST_SUCCESS = "BALANCE_MORELIST_SUCCESS";
export const BALANCE_MORELIST_FAILED = "BALANCE_MORELIST_FAILED";
///////////////

export const BALANCE_NEW_SUCCESS = "BALANCE_NEW_SUCCESS";
export const BALANCE_NEW_FAILED = "BALANCE_NEW_FAILED";
